import { Box, Typography } from "@mui/material";

type DashboardSectionProps = {
    title: string;
    subtitle?: string;
    headerControls?: React.ReactNode;
    children: React.ReactNode;
};

// Secção titulada reutilizável para dividir um dashboard em blocos (réplica dos cabeçalhos de secção
// do Zoho). O espaçamento ENTRE secções vem do gap do DashboardPage; aqui só se espaça o conteúdo interno.
// `headerControls` fica alinhado à direita do título: é onde vive o filtro de datas de uma secção cujos
// widgets partilham TODOS o mesmo período (um só seletor em vez de um por widget).
export const DashboardSection = ({ title, subtitle, headerControls, children }: DashboardSectionProps) => {
    return (
        <Box component="section">
            <Box mb={2.5} pb={1} borderBottom={1} borderColor="divider" display="flex" alignItems="flex-start" justifyContent="space-between" gap={2} flexWrap="wrap">
                <Box>
                    <Typography variant="h6" fontWeight={700}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" color="text.secondary" mt={0.5}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {headerControls && (
                    <Box display="flex" alignItems="flex-start" gap={2}>
                        {headerControls}
                    </Box>
                )}
            </Box>
            <Box display="flex" flexDirection="column" gap={3}>
                {children}
            </Box>
        </Box>
    );
};
